import { useEffect, useRef } from 'react'

import * as Amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { useMatches } from 'react-router'

import { useShubOrgInfo } from './useShubOrgInfo'
import { useUser } from './useUser'
import { addEventMetaPlugin } from '~/utils/shared/amplitude/clientPlugins'

export const useAmplitude = (amplitudeApiKey: string = '') => {

  const analyticsScriptsLoadedRef = useRef(false)
  const { user } = useUser()

  const { swaggerhubOrgId } = useShubOrgInfo()
  const matches = useMatches()
  
  useEffect(() => {
    if (amplitudeApiKey?.length &&
      !analyticsScriptsLoadedRef.current) {

      const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 0.8 })
      Amplitude.add(sessionReplayTracking)

      Amplitude.init(amplitudeApiKey,
        {
          fetchRemoteConfig: true,
          autocapture: true,
        },
      )

      void import('@amplitude/engagement-browser').then((mod) => {
        Amplitude.add(mod.plugin())
      })

      Amplitude.add(addEventMetaPlugin({ orgId: swaggerhubOrgId, routeId: matches.at(-1)?.id }))

      Amplitude.setUserId(user?.analyticsId)

      if (user?.email) {
        const identify = new Amplitude.Identify()
        identify.set('email', user?.email)
        Amplitude.identify(identify)
      }

      // due to strict mode, the root application is double loaded. 
      // this causes scripts to be loaded twice, so we block the second load
      analyticsScriptsLoadedRef.current = true
    }
  }, [])
}